module.exports = __webpack_public_path__ + "assets/img/evalItem02.7146b490.png";